import { CoursesTable } from './CoursesTable';

export default CoursesTable;
